// extracted by mini-css-extract-plugin
export default {"container":"TabBar_container__cB762","button":"TabBar_button__9MQiO","text":"TabBar_text__4bKPX"};